
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div class=\"user-card\">\n  <div class=\"avatar-wrapper card-view\"></div>\n  <div class=\"user-info\">\n    <div>\n      <div class=\"prefillEmail\">{{ email }}</div>\n    </div>\n  </div>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  